import MSOStyle from './parseMS/parseMSOCss';
import { getSolidHexColor, htmlToSdkScale, htmlToSdkFontScale, textBodySdkDataToHtml } from './ParserUtils';
import TextPasteParser from './TextPasteParser';
import { TableDefault } from '@src/slide/domain/ui-model/element-modeles/config/default-data/table-default';
import { LINE_DASH_VER3_MAP } from '@src/slide/domain/ui-model/converter/node-property/sdk-ui-enum-map/line-dash';
import _isEqual from 'lodash/isEqual';
import _fill from 'lodash/fill';
import _unset from 'lodash/unset';
import _get from 'lodash/get';
import set from 'lodash/set';
import { invertMap } from '@src/slide/infrastructure/module/independent/object/map-invert';

const defaultRowHeight = 28;// px 使用时需要配合 scale
const MSScale = 1.34;// 微软的宽

class TCPR {
    lnT: any;
    lnR: any;
    lnB: any;
    lnL: any;
    solidFill: {};
}

export default class TablePasteParserV3 {
    public static instance;
    public static getSingleton = () => {
        if (!TablePasteParserV3.instance) {
            TablePasteParserV3.instance = new TablePasteParserV3();
        }
        return TablePasteParserV3.instance;
    };

    public mSOStyle?: MSOStyle;

    public initParser(mSOStyle?: MSOStyle) {
        this.mSOStyle = mSOStyle;
    }

    // eslint-disable-next-line complexity
    public parseTableNodeToSdkData = (table, parsePasteHTML) => {
        const tableSdkData = TableDefault.makeDefaultSdkData(0, 0, 0, 0, 0, 0);

        // 初始化对象
        const tblColList = tableSdkData.graphic?.graphicData?.tbl?.tblGrid?.gridCol || [];
        const tblRowList = tableSdkData.graphic?.graphicData?.tbl?.tr || [];

        const tbody = table.getElementsByTagName('tbody')[0]; // 获得body
        if (!tbody) return;

        // 高度记录
        let tableHeight = 0;

        // 解析列信息
        const tbCols = table.getElementsByTagName('col'); // 行信息

        const getTblCol = (tbCol) => {
            const widthStr = tbCol.style.width;
            const width = parseInt(widthStr);
            const tblCol = {
                w: width * htmlToSdkScale,
            };
            return tblCol;
        };

        const fillCell = (width, colCount) => {
            if (tblColList && tblColList.length < 1) {
                const colWidth = width / colCount;
                for (let i = 0; i < colCount; i++) {
                    const tblCol = {
                        w: colWidth * htmlToSdkScale,
                    };
                    tblColList.push(tblCol);
                }
            }
        };

        const addTblColList = () => {
            for (let i = 0; i < tbCols.length; i++) {
                const spanStr = tbCols[i].getAttribute('span');
                if (spanStr) {
                    const span = parseInt(spanStr);
                    for (let j = 0; j < span; j++) {
                        const tblCol = getTblCol(tbCols[i]);
                        tblColList.push(tblCol);
                    }
                } else {
                    const tblCol = getTblCol(tbCols[i]);
                    tblColList.push(tblCol);
                }
            }
        };

        addTblColList();

        // 解析列信息

        // 解析行信息
        const trs = tbody.getElementsByTagName('tr');
        if (!trs) return;

        const getGridSpan = cell => (cell.getAttribute('colspan') ? parseInt(cell.getAttribute('colspan')) : 1);
        const rowCount = trs.length;
        let colCount = 0;
        if (rowCount > 0) {
            for (let index = 0; index < trs[0].children.length; index++) {
                const cell = trs[0].children[index];
                // eslint-disable-next-line radix
                const gridSpan = getGridSpan(cell);
                colCount += gridSpan;
            }
            const rowList: any[] = [];
            for (let i = 0; i < rowCount; i++) { // 填充全量数组
                tblRowList.push({ tc: new Array(colCount) });

                const tcList: any[] = [];
                for (let j = 0; j < trs[i].children.length; j++) {
                    tcList.push(trs[i].children[j]);
                }
                trs[i].tc = tcList; // 暂挂一下，为了转换成数组使用
                rowList.push(trs[i]);
            }

            tableHeight = this.processCells(rowList, tblRowList, tableHeight, parsePasteHTML);
        }

        // 设置表格props

        // 补充整表宽度信息
        const tableStyle = table.style;
        let width = parseInt(tableStyle.width);

        // 兼容腾讯文档的宽度
        if (!width) {
            width = 0;
            tblColList.forEach((element) => {
                width += element.w || 0;
            });
            width = width / htmlToSdkScale;
        }
        if (!width) { // 没有宽度信息，直接写默认
            width = 800;
        }

        // 补充列宽信息
        fillCell(width, colCount);

        if (tableSdkData?.spPr?.xfrm?.ext) {
            tableSdkData.spPr.xfrm.ext.cx = width * htmlToSdkScale;
            tableSdkData.spPr.xfrm.ext.cy = tableHeight * htmlToSdkScale;
        }

        // 设置表格props
        return tableSdkData;
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public processCells(rowList: any[], sdkRowList: any, tableHeight: number, parsePasteHTML) {
        rowList.forEach((row, rowIndex) => {
            const sdkRow = sdkRowList[rowIndex];
            const sdkTcList = sdkRow.tc;
            let colIndex = 0;
            let cursor = 0; // 当前要填充的单元格位置
            /** 计算行高 */
            const trStyle = this.getNodeComputedStyle(row);
            const heightStr = trStyle.height;
            // eslint-disable-next-line radix
            let height = parseInt(heightStr);
            if (!height) {
                height = defaultRowHeight; // 使用默认高度
            }
            set(sdkRow, 'h', height * htmlToSdkScale);
            // eslint-disable-next-line no-param-reassign
            tableHeight += height;
            const parseAttribute = (s, cell) => (cell.getAttribute(s) ? parseInt(cell.getAttribute(s)) : 0);
            while (colIndex < row.tc.length) {
                const cell = row.tc[colIndex];
                // eslint-disable-next-line radix
                const gridSpan = parseAttribute('colspan', cell);
                // eslint-disable-next-line radix
                const rowSpan = parseAttribute('rowspan', cell);
                const sdkTC = { txBody: { p: [] } };
                for (let index = cursor; index < sdkTcList.length; index++) { // 查找第一个没有填充的单元格
                    if (sdkTcList[index] === undefined) {
                        sdkTcList[index] = sdkTC;
                        cursor = index;
                        break;
                    }
                }
                /** 设置单元格属性 */
                const tcPr = this.getTcPr(cell);
                !_isEqual(tcPr, {}) && set(sdkTC, 'tcPr', tcPr);
                // 组装textBody
                const res = parsePasteHTML.parseNodes(cell);
                const hasNodes = res => res.nodes && res.nodes.length > 0;
                if (hasNodes(res)) {
                    const textSDKData = TextPasteParser.getSingleton().getTextBodyByNodes(res.nodes);
                    // 获取内容
                    const textBody = textSDKData;
                    set(sdkTC, 'txBody', textBody);
                }
                /** 处理合并单元格 */
                if (rowSpan > 1) { // 处理竖向合并
                    set(sdkTC, 'rowSpan', rowSpan);
                    // eslint-disable-next-line no-loop-func
                    this.processMergedCell(rowList, rowIndex, rowSpan, sdkRowList, cursor, gridSpan, sdkTC as any);
                } else if (gridSpan > 1) { // 处理横向合并
                    set(sdkTC, 'gridSpan', gridSpan);
                    _fill(
                        sdkRowList[rowIndex].tc,
                        {
                            hMerge: 1,
                            txBody: { p: [] },
                        },
                        cursor + 1, cursor + gridSpan,
                    );
                }
                cursor += (gridSpan || 1); // 调整游标位置，指向下一个要填充的单元格
                colIndex += 1;
            }
            _unset(row, 'tc'); // 还原数据
        });
        return tableHeight;
    }


    public getTcPr(td) {
        const tcPr: TCPR = new TCPR();
        const setTdStyle = () => this.getNodeComputedStyle(td) || td.style;
        const tdStyle = setTdStyle();

        const borderWidthStr = tdStyle['border-width'];

        const setTcPrWithborderWidthStr = () => {
            const borderStyleStr = tdStyle['border-style'];
            const borderColorStr = tdStyle['border-color'];
            const lns = this.getBorderPropsByAttr(borderWidthStr, borderStyleStr, borderColorStr);
            const hasFourLns = lns => lns && lns.length === 4;
            if (hasFourLns(lns)) {
                [tcPr.lnT, tcPr.lnR, tcPr.lnB, tcPr.lnL] = lns;
            }
        };
        if (borderWidthStr && borderWidthStr.length > 0) {
            // 属性的方式创建边框
            setTcPrWithborderWidthStr();
        }

        const { border } = tdStyle;
        if (this.checkStyle(border)) {
            const ln = this.getBorderProps(border);
            if (ln) {
                tcPr.lnT = ln;
                tcPr.lnB = ln;
                tcPr.lnL = ln;
                tcPr.lnR = ln;
            }
        }

        const borderTop = tdStyle['border-top'];
        if (this.checkStyle(borderTop)) {
            const lnT = this.getBorderProps(borderTop);
            tcPr.lnT = lnT;
        }
        const borderBottom = tdStyle['border-bottom'];
        if (this.checkStyle(borderBottom)) {
            const lnB = this.getBorderProps(borderBottom);
            tcPr.lnB = lnB;
        }
        const borderLeft = tdStyle['border-left'];
        if (this.checkStyle(borderLeft)) {
            const lnL = this.getBorderProps(borderLeft);
            tcPr.lnL = lnL;
        }
        const borderRight = tdStyle['border-right'];
        if (this.checkStyle(borderRight)) {
            const lnR = this.getBorderProps(borderRight);
            tcPr.lnR = lnR;
        }
        const setBackgroundStr = () => tdStyle.background || tdStyle['background-color']; // 兼容浏览器格式
        const backgroundStr = setBackgroundStr();
        const background = getSolidHexColor(backgroundStr);
        if (background) {
            set(tcPr, 'solidFill.egColorChoice.srgbClr.val', background);
        }

        return tcPr;
    }

    public checkStyle(style) {
        return style && style !== 'none';
    }

    // eslint-disable-next-line complexity
    public getBorderPropsByAttr(borderWidthStr, borderStyleStr, borderColorStr) {
        if (!borderWidthStr || !borderStyleStr || !borderColorStr) {
            return undefined;
        }

        let borderWidths: Array<number> = [];
        if (borderWidthStr) {
            borderWidths = borderWidthStr.split(' ').map(w => parseFloat(w)); // 提取border-width属性，可能为一个值或者四个值
        }
        while (borderWidths.length < 4) {
            borderWidths.push(0);
        }

        const borderColors: any = [];
        const tempBorderColorStr = borderColorStr.replace(/\s+/g, '');
        let startIndex = 0;
        let endIndex = tempBorderColorStr.indexOf(')', startIndex);
        while (endIndex > 0) {
            endIndex += 1;
            let color = tempBorderColorStr.substring(startIndex, endIndex);
            color = getSolidHexColor(color);
            borderColors.push(color);
            startIndex = endIndex;
            endIndex = tempBorderColorStr.indexOf(')', startIndex);
        }
        const notSetBorderProps = (borderColors, endIndex) => borderColors.length === 0 && endIndex < 0;
        if (notSetBorderProps(borderColors, endIndex)) {
            // 提取border-color属性，可能为一个值或者四个值
            borderColorStr.split(' ').forEach((element) => {
                const color = getSolidHexColor(element);
                borderColors.push(color);
            });
        }
        while (borderColors.length < 4) {
            borderColors.push(borderColors[borderColors.length - 1]);
        }

        const result: any = [];
        for (let index = 0; index < 4; index++) {
            const width = borderWidths[index] * htmlToSdkScale;
            const color = borderColors[index];
            const item = {
                w: width,
                egLineDashProperties: { prstDash: { val: invertMap(LINE_DASH_VER3_MAP).get(borderStyleStr) } },
                egLineFillProperties: { solidFill: { egColorChoice: { srgbClr: { val: color } } } },
            };
            result.push(item);
        }
        return result;
    }
    // 获取边框属性
    public getBorderProps(borderStyleStr) {
        const find = (str, cha, num) => {
            let x = str.indexOf(cha);
            for (let i = 0; i < num; i++) {
                x = str.indexOf(cha, x + 1);
            }
            return x;
        };

        // 之所以这么写，是因为颜色有3中格式需要支持 #xxxxxx  red   rgb (xxx,xxx,xxx)
        const widthEndIndex = find(borderStyleStr, ' ', 0);
        const prstDashEndIndex = find(borderStyleStr, ' ', 1);

        const widthStr = borderStyleStr.substring(0, widthEndIndex);
        const prstDash = borderStyleStr.substring(widthEndIndex + 1, prstDashEndIndex);
        let colorStr = borderStyleStr.substring(prstDashEndIndex + 1);

        let width = 0;
        if (widthStr) {
            width = parseFloat(widthStr);
        }
        if (colorStr === 'windowtext') {
            colorStr = 'black';
        }
        const color = getSolidHexColor(colorStr);
        if (color) {
            return {
                w: width * htmlToSdkScale,
                egLineDashProperties: { prstDash: { val: invertMap(LINE_DASH_VER3_MAP).get(prstDash) } },
                egLineFillProperties: { solidFill: { egColorChoice: { srgbClr: { val: color } } } },
            };
        }
        return undefined;
    }

    public getNodeComputedStyle(node) {
        let style = this.mSOStyle?.getComputedStyle(node);
        if (!style) {
            style = node.style;
        }
        return style;
    }

    public parseTextNodeToTextBody = (element) => {
        if (!element) {
            return;
        }

        // 处理纯文本
        let innerHTML;
        if (element.nodeType === 3) {
            // eslint-disable-next-line no-param-reassign
            element.innerText = element.textContent;
        } else {
            innerHTML = element.innerHTML;
        }
        if (innerHTML?.indexOf(/<span style="mso-spacerun:yes">/)) {
            // eslint-disable-next-line no-param-reassign
            element.innerHTML = innerHTML.replace(
                /<span .*style="mso-spacerun:yes">\s*<\/span>/g,
                '',
            );
        }
        const innerText = element.innerText || element.textContent || '';

        const txBody = {
            p: [],
        };
        const textRun: any = {
            r: {
                rPr: {
                    lang: 'zh-CN',
                },
                t: '',
            },
        };
        textRun.t = innerText;
        // 处理纯文本

        // 文字颜色
        let tdStyle = this.getNodeComputedStyle(element);
        tdStyle = tdStyle || element.style;
        const color = getSolidHexColor(tdStyle.color); // 文字颜色
        if (color) {
            textRun.r.rPr.solidFill = { egColorChoice: { srgbClr: { val: color } } };
        }

        // 文字字号
        const fontSize = tdStyle['font-size'];
        if (fontSize) {
            textRun.r.rPr.sz = parseInt(fontSize) * htmlToSdkFontScale;
        }

        (txBody.p as any).push({ egTextRun: [textRun] });
        return txBody;
    };

    public getLnHtmlStyle(ln, propKey = '') {
        let str = '';
        if (ln.egLineFillProperties) {
            str += ln.egLineFillProperties?.noFill ? '' : `${propKey} ${ln.w / htmlToSdkScale}pt`;
        }
        if (str) {
            str += ` ${LINE_DASH_VER3_MAP.get(ln.egLineDashProperties?.prstDash?.val) || 'solid'}`;
        }
        if (str) {
            str += ` ${this.getEgColorChoiceRgba(ln.egLineFillProperties?.solidFill?.egColorChoice?.srgbClr) || '#000000'}`;
        }
        return `${str};`;
    }

    public getBorderStyleSingleContent(styleContent, tdData) {
        let result = '';
        const _getStyle = (position: string, ln) => (ln.egLineFillProperties.noFill ? '' : `${position}: ${this.getLnHtmlStyle(ln)};`);

        if (_get(tdData, 'tcPr.lnT.egLineFillProperties.solidFill.egColorChoice')) {
            const { lnT } = tdData.tcPr;
            result += _getStyle('border-top', lnT);
        }

        if (_get(tdData, 'tcPr.lnR.egLineFillProperties.solidFill.egColorChoice')) {
            const { lnR } = tdData.tcPr;
            result += _getStyle('border-right', lnR);
        }

        if (_get(tdData, 'tcPr.lnB.egLineFillProperties.solidFill.egColorChoice')) {
            const { lnB } = tdData.tcPr;
            result += _getStyle('border-bottom', lnB);
        }

        if (_get(tdData, 'tcPr.lnL.egLineFillProperties.solidFill.egColorChoice')) {
            const { lnL } = tdData.tcPr;
            result += _getStyle('border-left', lnL);
        }
        return result;
    }

    // eslint-disable-next-line complexity
    public getBorderStyleContent(tdData) {
        let styleContent = '';
        if (tdData.tcPr) {
            styleContent = this.getBorderStyleSingleContent(styleContent, tdData);

            try {
                const lt = JSON.stringify(tdData.tcPr.lnT);
                const lr = JSON.stringify(tdData.tcPr.lnR);
                const lb = JSON.stringify(tdData.tcPr.lnB);
                const ll = JSON.stringify(tdData.tcPr.lnL);
                const checkIdentical = (lt, lr, lb, ll) => lt === lr && lr === lb && lb === ll;
                if (checkIdentical(lt, lr, lb, ll)) {
                    const { lnT } = tdData.tcPr;
                    styleContent += this.getLnHtmlStyle(lnT, 'border:');
                }
            } catch (error) {
                window.log?.error(error);
            }

            // 组装背景颜色
            if (tdData?.tcPr?.solidFill?.egColorChoice?.srgbClr) {
                const color = this.getEgColorChoiceRgba(tdData.tcPr.solidFill.egColorChoice.srgbClr);
                styleContent += `background:${color};`;
                styleContent += `background-color:${color};`;
            }
        }
        return styleContent;
    }

    public parseSdkDataToHtml(tableSdkData) {
        const html = document.createElement('html');
        html.setAttribute('xmlns:x', 'tencent');
        const head = document.createElement('head');
        const style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        const body = document.createElement('body');
        const startTextNode = document.createTextNode('<!--StartFragment-->');
        body.appendChild(startTextNode);
        const table = document.createElement('table');
        table.setAttribute('style', 'border-collapse:collapse');
        table.setAttribute('selecttype', 'cells');

        // 预处理 记录所有宽度  单位style中的width
        const widthArray: number[] = [];

        const tblColList = tableSdkData.graphic.graphicData.tbl.tblGrid.gridCol;
        const tblRowList = tableSdkData.graphic.graphicData.tbl.tr;

        // col区域
        tblColList.forEach((colData) => {
            const col = document.createElement('col');
            const colW = colData.w / htmlToSdkScale;
            widthArray.push(colW);
            col.setAttribute('width', `${colW * MSScale}`);
            const styleStr = `width:${colW}pt`;
            col.setAttribute('style', styleStr);
            table.appendChild(col);
        });

        // 预处理 记录所有高度
        const heightArray: number[] = [];
        tblRowList.forEach((row) => {
            const trH = row.h / htmlToSdkScale;
            heightArray.push(trH);
        });

        let msStyleString = 'td{padding-top:1px;padding-right:1px;padding-left:1px;color:black;font-size:18.0pt;font-weight:400;font-style:normal;text-decoration:none;font-family:DengXian;text-align:general;vertical-align:bottom;border:none;white-space:nowrap;}ruby{ruby-align:left;}rt{color:windowtext;font-size:9.0pt;font-weight:400;font-style:normal;text-decoration:none;font-family:DengXian;display:none;}';

        // tr
        let customerStyleIndex = 65;// 微软也是从65开始 对应 .xl65
        tblRowList.forEach((row, rowIndex) => {
            const trH = row.h / htmlToSdkScale;
            const tr = document.createElement('tr');
            tr.setAttribute('height', `${trH}`);
            const styleStr = `height:${trH}`;
            tr.setAttribute('style', styleStr);

            row.tc.forEach((tdData, colIndex) => {
                if (tdData.hMerge || tdData.vMerge) { // 被merge的元素直接跳过
                    return;
                }

                const td = document.createElement('td');
                let width = widthArray[colIndex];
                let height = heightArray[rowIndex];
                if (tdData.gridSpan) {
                    td.setAttribute('colspan', `${tdData.gridSpan}`);
                    for (let i = 1; i < tdData.gridSpan; i++) {
                        width += widthArray[colIndex + i];
                    }
                }
                if (tdData.rowSpan) {
                    td.setAttribute('rowspan', `${tdData.rowSpan}`);
                    for (let i = 1; i < tdData.rowSpan; i++) {
                        height += heightArray[rowIndex + i];
                    }
                }
                td.setAttribute('width', `${width}`);
                td.setAttribute('height', `${height}`);

                const tdClassName = `xl${customerStyleIndex}`;
                customerStyleIndex += 1;
                td.setAttribute('class', tdClassName);


                // 组装边框
                let styleString = `.${tdClassName}{`;
                let styleContent = '';
                styleContent += `height:${height}pt;`;

                // 设置边框
                styleString += this.getBorderStyleContent(tdData);
                styleString += '}';

                td.setAttribute('style', styleContent);
                msStyleString += styleString;

                // 处理textRun内容
                const textBodyHtml = textBodySdkDataToHtml(tdData);
                td.innerHTML = textBodyHtml;
                tr.appendChild(td);
            });
            table.appendChild(tr);
        });

        // 样式处理
        msStyleString = `<!--${msStyleString}-->`; // 添加微软格式
        const textNode = document.createTextNode(msStyleString);
        style.appendChild(textNode);

        head.appendChild(style);
        html.appendChild(head);
        body.appendChild(table);
        const entTextNode = document.createTextNode('<!--EndFragment-->');
        body.appendChild(entTextNode);
        html.appendChild(body);
        let tableHtml = html.outerHTML;

        tableHtml = tableHtml.replace(new RegExp(/&lt;!--StartFragment--&gt;/, 'gm'), '<!--StartFragment-->');
        tableHtml = tableHtml.replace(new RegExp(/&lt;!--EndFragment--&gt;/, 'gm'), '<!--EndFragment-->');

        return tableHtml;
    }

    /**
     * table to plain text
     * @param tableSdkData
     */
    public parseSdkDataToPlainText(tableSdkData): string {
        const txt: Array<string> = [];
        const plainTextFromTextBody = (cell) => {
            let cellTxt = '';
            const paragraphList = cell.txBody?.p;
            if (paragraphList?.length > 0) {
                paragraphList.forEach((paragraph) => {
                    paragraph.egTextRun?.forEach((textRun) => {
                        const { t } = textRun?.r || {};
                        cellTxt += t || '';
                    });
                });
            }
            return cellTxt;
        };
        tableSdkData.graphic.graphicData.tbl.tr.forEach((row) => {
            const rowTxt: Array<string> = [];
            row.tc.forEach((cell) => {
                rowTxt.push(plainTextFromTextBody(cell));
            });
            txt.push(rowTxt.join('\t'));
        });

        return txt.join('\n\r');
    }

    private processMergedCell(
        rowList: any[],
        rowIndex: number,
        rowSpan: number,
        sdkRowList: any,
        cursor: number,
        gridSpan: number,
        sdkTC: { txBody: { p: any[] } },
    ) {
        rowList.slice(rowIndex, rowIndex + rowSpan).forEach((_r, i) => {
            if (i > 0) { // 从下一行开始填充当前列的单元格
                // eslint-disable-next-line no-param-reassign
                sdkRowList[rowIndex + i].tc[cursor] = {
                    vMerge: 1,
                    txBody: { p: [] },
                };
            }
            if (gridSpan && gridSpan > 1) { // 从下一列开始填充当前行横向合并单元格
                set(sdkTC, 'gridSpan', gridSpan);
                _fill(
                    sdkRowList[rowIndex + i].tc,
                    i === 0 ? {
                        hMerge: 1,
                        txBody: { p: [] },
                    } : {
                        hMerge: 1,
                        vMerge: 1,
                        txBody: { p: [] },
                    },
                    cursor + 1,
                    cursor + gridSpan,
                );
            }
        });
    }

    private getEgColorChoiceRgba(srgbClr: { val: string }) {
        return `#${srgbClr.val.replace('#', '')}`;
    }
}
